import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import CombustivelService from "../../services/CombustivelService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormCombustivel extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idCombustivel: "",
            nome: ""
        };

        this.state.crud = {
            service: CombustivelService,
            labels: {
                title: 'Combustível',
            },
            urlList: '/LstCombustivel',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idCombustivel} name="idCombustivel" readOnly opcionalLabel={false}/>
                <InputText label="Nome do Combustível" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormCombustivel {...props} navigate={navigate} params={params} />
}

export default With